import { render, staticRenderFns } from "./Detalhes_Usuario.vue?vue&type=template&id=70cc55ce&"
import script from "./Detalhes_Usuario.vue?vue&type=script&lang=js&"
export * from "./Detalhes_Usuario.vue?vue&type=script&lang=js&"
import style0 from "./Detalhes_Usuario.vue?vue&type=style&index=0&id=70cc55ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports